import { useQuery } from 'react-query';

import { getStoredFilterBulkAssignToUser as queryFn } from 'api/endPoints/getStoredFilterBulkAssignToUser';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetStoredFilterBulkAssignToUser = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys]>({
        queryKey: ['getStoredFilterBulkAssignToUser'],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.contractId),
    });
};

export interface QueryParams {
    contractId?: number;
}

export interface QueryResponse {
    info: IToolTip;
    userAssignRule: {
        lastRunActivities: number;
        id: number;
        ruleRank: number;
        appliedFilter: string;
        LastRunActivities: number;
        updatedBy: string;
        updatedByName: string;
        lastUpdate: number;
        assignee: string;
        assigneeName: string;
    }[];
}
